import Vue from "vue";
import { VApp, VTabs, VTab, VTabsSlider, VTabsItems, VTabItem, VCard, VCardText } from "vuetify/lib";

Vue.component("v-app", VApp);
Vue.component("v-tabs", VTabs);
Vue.component("v-tab", VTab);
Vue.component("v-tabs-slider", VTabsSlider);
Vue.component("v-tabs-items", VTabsItems);
Vue.component("v-tab-item", VTabItem);
Vue.component("v-card", VCard);
Vue.component("v-card-text", VCardText);

export default {};
